import React, { Component } from "react"
import DatePicker from "react-datepicker";
import moment from 'moment'
class ValidationDatePicker extends Component {
  state = {
    hasError: false
  };
  constructor(props) {
    super(props)
    this.props.onBlur({ name: this.props.name, hasError: true })
    if (this.props.selected) {
      this.props.onBlur({ name: this.props.name, hasError: isYounger(this.props.selected, 18) })
    }
  }
  componentWillReceiveProps(nextProps) { 
    if (nextProps.selected && this.props.selected) {
      if (nextProps.selected.format("DD-MMM-YYYY") !== this.props.selected.format("DD-MMM-YYYY")) {
        nextProps.onBlur({ name: nextProps.name, hasError: isYounger(nextProps.selected, 18) });
      }
    }
  }

  handleOnEvent = (event, onEvent) => {
    const value = event.target.value;
    this.setState({ hasError: value === "" || isYounger(this.props.selected, 18) });
    onEvent({ name: this.props.name, hasError: value === "" || isYounger(this.props.selected, 18) }, event);
  };
  handleOnChange = (date, onEvent) => {
    const value = date;
    this.setState({ hasError: isYounger(value, 18) });
    onEvent({ name: this.props.name, hasError: isYounger(value, 18) }, date);
  };
  render() {
    const {placeholderText, onChange, onBlur, name, selected, checkFullFields, minDate, maxDate} = this.props
    const errorClass = "aps-section-register-fields-required";
    return (
      <div>
      <DatePicker
      className={`uk-input aps-section-register-fields
        ${this.state.hasError ? errorClass : ""}
        ${checkFullFields ? "aps-full-all-fields-data" : " "}`
      }
      dateFormat="DD-MMM-YYYY"
      name={name}
      placeholderText={placeholderText}
      minDate={minDate}
      maxDate={maxDate}
      locale="fr"
      readOnly
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      selected={selected}
      onBlur={event => this.handleOnEvent(event, onBlur)}
      onChange={date => this.handleOnChange(date, onChange)}
    />
    {this.state.hasError && (<p style={{marginBottom: "0px"}} className="uk-text-left aps-section-register-fields-required-alert">
    Le souscripteur doit avoir au moins 18 ans.
    </p>)}
    </div>);
  }
}
// function isOlder(birthday, limitAge) {
//   let age = moment().diff(birthday, 'years')
//   return age > limitAge
// }
function isYounger(birthday, limitAge) {
  let age = moment().diff(moment(birthday, "DD-MMM-YYYY"), 'years')
  return age < limitAge
}
export default ValidationDatePicker



// WEBPACK FOOTER //
// ./src/components/ValidationDatePicker/souscripteur.js